import {NumericUtilities} from "../../Utilities/NumericUtilities";
import {PriceTypeEnum} from "../../Fields/Core/FBFieldWithPriceBase.Options";
import {FBFieldWithPriceBaseModel} from "FormBuilder/Fields/Core/FBFieldWithPriceBase.Model";
import {FBFieldBaseModel} from "FormBuilder/Fields/Core/FBFieldBase.Model";
import {SingleEvent} from "shared/core/Events/SingleEvent";

export abstract class CalculatorBase {
    public PriceUpdated:SingleEvent<FBFieldBaseModel>;
    public RequireInstanceToCalculate:boolean;
    private Price:number;
    private UnitPrice:number;
    private RegularPrice:number;
    private SalePrice:number;
    public LastInstance:HTMLDivElement;
    public IsSale:boolean;
    Field:FBFieldWithPriceBaseModel;
    constructor()
    {
        this.PriceUpdated=new SingleEvent();
        this.Price=null;
        this.UnitPrice=null;
        this.SalePrice=null;
        this.RegularPrice=null;
        this.RequireInstanceToCalculate=false;
        this.ExecuteCalculation=this.ExecuteCalculation.bind(this);


    }

    public GetDependsOnOtherFields(){
        return false;
    }

    public GetUnitPrice(){
        return this.UnitPrice;
    }

    public Destroy(){
        this.PriceUpdated.Unsubscribe(this);
        this.Field.ValueChanged.Unsubscribe(this);
    }

    public Initialize(Field:FBFieldWithPriceBaseModel){
        this.InitializeFieldOnly(Field);
        return this;
    }

    public GetForceUpdateWhenFieldChange(){
        return false;
    }

    public InitializeFieldOnly(Field:FBFieldWithPriceBaseModel)
    {
        this.Field=Field;
        return this;
    }

    public ExecuteAndUpdate(forceUpdate:boolean=false,skipValueChangedEvent:boolean=false){
        let prices=this.ExecuteCalculation(null,null,null);
        return this.UpdatePrice(prices.RegularPrice,prices.SalePrice,prices.Quantity,forceUpdate,skipValueChangedEvent);
    }



    public GetQuantityInput(){
        if(this.Field.Options.ShowQuantitySelector==false||this.Field.Options.PriceType==PriceTypeEnum.quantity)
            return 1;
        else
        {
            let value=this.Field.Quantity;
            return NumericUtilities.ParseNumber(value,0);
        }
    }

    public GetIsUsed(){
        return this.Field.GetIsUsed();
    }

    public GetIsSale(){
        return this.IsSale;
    }

    public GetPrice(){
        if(this.GetIsUsed())
            return this.Price;
        else
            return 0;
    }


    public GetSalePrice(){
        if(this.GetIsUsed())
            return this.SalePrice;
        else
            return  0;
    }

    public GetQuantity(){
        if(this.GetIsUsed())
            return this.Field.Quantity;
        else
            return 0;
    }

    public IsDynamic(){
        return false;
    }

    GetRegularPrice(): number {
        return this.RegularPrice;
    }



    public UpdatePrice(newPrice:any,newSalePrice:any='',newQuantity:number=0,forceUpdate:boolean=false,skipValueChangedEvent:boolean=false){

        let previousIsUsed=this.GetIsUsed();
        let originalPrice=this.Price;
        let originalSale=this.SalePrice;
        let originalQuantity=this.Field.Quantity;

        let newConvertedPrice=newPrice==''?0:newPrice;
        let newConvertedSalePrice=newSalePrice==''?0:newSalePrice;
        if(newPrice===''&&newSalePrice==='')
        {
            this.Price=0;
            this.SalePrice=0;
            this.Field.Quantity=newQuantity;
            this.UnitPrice=0;

        }else {
            this.Field.Quantity=newQuantity;
            let price = NumericUtilities.ParseNumber(newPrice, 0);
            if (newSalePrice != '') {
                this.IsSale = true;
                let salePrice = NumericUtilities.ParseNumber(newSalePrice, 0);
                this.Price = salePrice*newQuantity;
                this.SalePrice = salePrice*newQuantity;
                this.RegularPrice = price *newQuantity;
                this.UnitPrice=salePrice;

            } else {
                this.IsSale = false;
                this.Price = price*newQuantity;
                this.UnitPrice=this.Price;
                this.SalePrice = 0;
                this.RegularPrice = price*newQuantity;
            }
        }


        if(forceUpdate||(newConvertedPrice!==originalPrice||newConvertedSalePrice!==originalSale||previousIsUsed!=this.GetIsUsed())) {
            this.PriceUpdated.Publish(this.Field);
            if(!skipValueChangedEvent)
                this.Field.FireValueChanged();
            return true;
        }
    }

    public abstract ExecuteCalculation(value:any,regularPrice:any,salePrice:any):{RegularPrice:any,SalePrice:any,Quantity:number} ;


}


